import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DataTable from "react-data-table-component";
import Select from "react-select";

import { API_BASE_URL } from "../../../config";
import {
  statisticsAction,
  statisticsCloseAction,
} from "../../../actions/settingsAction";

const Floor = (props) => {
  const { fixNavbar } = props;

  /* ------------------ STATE ------------------ */
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [formData, setFormData] = useState({
    floor_name: "",
    dept_head: "",
    company_id: "",
  });

  const [user, setUser] = useState({
    floor_id: "",
    floor_name: "",
    dept_head: "",
  });

  const [employees, setEmployees] = useState([]);
  const [companies, setCompanies] = useState([]);

  /* ------------------ FETCH DATA ------------------ */
  const fetchFloors = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/floor_list`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });
      setData(res.data.data.leave_type || []);
    } catch (err) {
      toast.error("Failed to load floors");
    }
    setLoading(false);
  };

  const fetchEmployees = async () => {
    const res = await axios.get(`${API_BASE_URL}/all_employees`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    setEmployees(res.data.data.all_employee || []);
  };

  const fetchCompanies = async () => {
    const res = await axios.get(`${API_BASE_URL}/all_companys`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    setCompanies(res.data.data.all_employee || []);
  };

  useEffect(() => {
    fetchFloors();
    fetchEmployees();
    fetchCompanies();
  }, []);

  /* ------------------ FILTER ------------------ */
  const filteredData = data.filter((item) =>
    `${item.floor_name} ${item.incharge} ${item.name}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  /* ------------------ ADD FLOOR ------------------ */
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API_BASE_URL}/add_floor`, formData, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });
      if (res.data.status === "success") {
        toast.success(res.data.message);
        fetchFloors();
        setFormData({ floor_name: "", dept_head: "", company_id: "" });
      } else {
        toast.error(res.data.message);
      }
    } catch {
      toast.error("Add failed");
    }
  };

  /* ------------------ EDIT FLOOR ------------------ */
  const handleUpdate = async (id) => {
    const res = await axios.get(`${API_BASE_URL}/showfloor/${id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    setUser(res.data);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `${API_BASE_URL}/updatefloor`,
        {
          floor_id: user.floor_id,
          floor_name: user.floor_name,
          dept_head: user.dept_head,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      if (res.data.status === "success") {
        toast.success(res.data.message);
        fetchFloors();
        window.$("#exampleEditModal").modal("hide");
      } else {
        toast.error(res.data.message);
      }
    } catch {
      toast.error("Update failed");
    }
  };

  /* ------------------ DATATABLE COLUMNS ------------------ */
  const columns = [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      width: "80px",
    },
    {
      name: "Floor Name",
      selector: (row) => row.floor_name,
      sortable: true,
    },
    {
      name: "Floor Incharge",
      selector: (row) => row.incharge,
      sortable: true,
    },
    {
      name: "Company",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <button
          className="btn btn-icon btn-sm"
          data-toggle="modal"
          data-target="#exampleEditModal"
          onClick={() => handleUpdate(row.floor_id)}
        >
          <i className="fa fa-edit" />
        </button>
      ),
      ignoreRowClick: true,
      button: true,
    },
  ];

  /* ------------------ RENDER ------------------ */
  return (
    <>
      <ToastContainer position="bottom-right" />

      <div className={`section-body ${fixNavbar ? "marginTop" : ""}`}>
        <div className="container-fluid">

          {/* ADD FLOOR */}
          <div className="card mb-4">
            <div className="card-header">
              <h3 className="card-title">Add Floor</h3>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-3 required-tooltip">
                    <label>Floor Name</label>
                    <input
                      className="form-control required-input"
                      value={formData.floor_name}
                      onChange={(e) =>
                        setFormData({ ...formData, floor_name: e.target.value })
                      }
                      
                    />
                  </div>

                  <div className="col-md-3">
                    <label>Floor Incharge</label>
                    <Select classNames={{
    control: () => "required-select required-tooltip"
  }}
                      options={employees}
                      onChange={(s) =>
                        setFormData({ ...formData, dept_head: s.value })
                      }
                    />
                  </div>

                  <div className="col-md-3">
                    <label>Company</label>
                    <Select classNames={{
    control: () => "required-select required-tooltip"
  }}
                      options={companies}
                      onChange={(s) =>
                        setFormData({ ...formData, company_id: s.company_id })
                      }
                    />
                  </div>

                  <div className="col-md-2 d-flex align-items-end">
                    <button className="btn btn-primary w-100">Add</button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* FLOOR LIST */}
          <div className="card">
            <div className="card-header d-flex justify-content-between">
              <h3 className="card-title" style={{ color: "#e96827" }}>
                Floor List
              </h3>
              <input
                className="form-control form-control-sm"
                placeholder="Search"
                style={{ width: 200 }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="card-body">
              <DataTable
                columns={columns}
                data={filteredData}
                progressPending={loading}
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                highlightOnHover
                striped
                responsive
                persistTableHead
                noDataComponent="No floors found"
              />
            </div>
          </div>
        </div>
      </div>

      {/* EDIT MODAL */}
      <div className="modal fade" id="exampleEditModal">
        <div className="modal-dialog">
          <form onSubmit={handleEditSubmit}>
            <div className="modal-content">
              <div className="modal-header">
                <h5>Edit Floor</h5>
                <button className="close" data-dismiss="modal">×</button>
              </div>
              <div className="modal-body">
                <input
                  className="form-control mb-2"
                  value={user.floor_name}
                  onChange={(e) =>
                    setUser({ ...user, floor_name: e.target.value })
                  }
                />
                <Select
                  options={employees}
                  value={employees.find((e) => e.value === user.dept_head)}
                  onChange={(s) =>
                    setUser({ ...user, dept_head: s.value })
                  }
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" data-dismiss="modal">
                  Close
                </button>
                <button className="btn btn-primary">Save</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar,
});

export default connect(mapStateToProps)(Floor);
